var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "Person_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6D4FA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63DFA8",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0h34a8 8 0 018 8v34a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z",
    fill: "url(#Person_svg__[object_Object]a)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 35.819c-.649.119-1.317.181-2 .181-6.075 0-11-4.925-11-11s4.925-11 11-11a11 11 0 019.798 6H26a2 2 0 00-2 2v13.819zM14 24c.04 2.238 1.826 4.024 4 4 2.174.024 3.96-1.762 4-4-.045-2.235-1.828-4.018-4-4-2.177-.03-3.966 1.76-4 4zm.49 5.67c1.62 2.586 4.458 4.208 7.51 4.21a9.15 9.15 0 002-.21c-.84-2.75-2.57-5-6-5a5.75 5.75 0 00-3.51 1z",
    opacity: 0.504
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 22h10a1 1 0 011 1v6a1 1 0 01-1 1H27a1 1 0 01-1-1v-6a1 1 0 011-1zm0 10h10a1 1 0 011 1v2a1 1 0 01-1 1H27a1 1 0 01-1-1v-2a1 1 0 011-1zm1.5-8a.5.5 0 000 1h7a.5.5 0 100-1h-7zm0 2a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 7a.5.5 0 100 1h6a.5.5 0 100-1h-6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default ForwardRef;